import React from 'react';
import { styled } from '@mui/system';
import { Fab, Tooltip } from '@mui/material';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import config from '../../../config';
import { isLegacyForm } from '../../../utils/formTypeConstants';

const calculatePosition = ({
  openTestPanel,
  isForm,
}) => {
  // Get the correct width value from config
  const baseWidthKey = isForm ? 'FORM_PANE_WIDTH' : 'PANE_WIDTH';
  const baseWidth = config[baseWidthKey] || '0px';

  // Create a CSS calc expression to position the button at the edge of the pane
  let calcExpression = baseWidth;

  if (openTestPanel && config.TEST_PANE_WIDTH) {
    calcExpression = `calc(${calcExpression} + ${config.TEST_PANE_WIDTH})`;
  }

  // Add a small offset for better positioning
  calcExpression = `calc(${calcExpression} + 8px)`;

  return calcExpression;
};

const StyledFab = styled(Fab, {
  shouldForwardProp: prop =>
    !['openTestPanel', 'isForm', 'isForceStart'].includes(prop),
})(({ theme, ...props }) => ({
  background: theme.palette.background.paper,
  position: 'fixed',
  top: '50vh',
  right: calculatePosition(props),
  zIndex: 1000,
  borderRadius: '8px',
  boxShadow: '0px 2px 8px rgba(0, 0, 0, 0.12)',
  border: `1px solid ${theme.palette.divider}`,
  width: '36px',
  height: '36px',
  minHeight: 'auto',
  '&:hover': {
    background: theme.palette.action.hover,
    boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.18)',
    transition: 'all 0.2s ease-in-out',
  },
  transition: 'all 0.2s ease-in-out',
}));

const RightArrow = styled(ChevronRightIcon)(({ theme }) => ({
  color: theme.palette.text.secondary,
  fontSize: '1.1rem',
  transition: 'color 0.2s ease',
}));

function ClosePaneButton({
  handleClose,
  openTestPanel,
  editComponent,
}) {
  const isForm =
    editComponent && isLegacyForm(editComponent.type);
  const isFullScreen = window.location.href.includes('fullScreen=true');
  const isForceStart = window.location.href.includes('force_start');

  if (!isFullScreen && editComponent) {
    return (
      <Tooltip
        title="Close pane"
        placement="left"
        arrow
        enterDelay={500}
        leaveDelay={200}
        sx={{
          '& .MuiTooltip-tooltip': {
            backgroundColor: 'rgba(33, 33, 33, 0.9)',
            fontSize: '0.75rem',
            padding: '6px 12px',
            borderRadius: '4px',
          },
          '& .MuiTooltip-arrow': {
            color: 'rgba(33, 33, 33, 0.9)',
          },
        }}
      >
        <StyledFab
          size="small"
          onClick={handleClose}
          openTestPanel={openTestPanel}
          isForm={isForm}
          isForceStart={isForceStart}
        >
          <RightArrow fontSize="medium" />
        </StyledFab>
      </Tooltip>
    );
  }
  return null;
}

export default ClosePaneButton;
